import type { TutorialDetailMap } from '@/utils/tutorialTypes';

export const tutorialDetailsMt5OrderTrouble: TutorialDetailMap = {
  'mt5-open-close-order': {
    intro: [
      'หน้าต่าง New Order ของ MT5 แยกประเภทคำสั่งชัดเจนกว่า MT4 และปิดสถานะได้จากแท็บ Trade ใน Toolbox',
      'จุดที่ต่างจาก MT4 มากที่สุดคือบัญชีแบบ Netting จะรวมออเดอร์ทิศเดียวกันเป็นสถานะเดียว ซึ่งกระทบวิธีปิดออเดอร์โดยตรง',
    ],
    sections: [
      {
        heading: 'เปิดหน้าต่าง New Order',
        paragraphs: [
          'กด F9 หรือคลิกขวาที่กราฟเลือก Trading > New Order ระบบจะเลือกคู่เงินของกราฟที่กำลังดูให้อัตโนมัติ',
          'ในหน้าต่างนี้มีช่อง Symbol, Volume, Stop Loss, Take Profit และประเภทคำสั่ง ซึ่งเลือกได้ทั้ง Market Execution และ Pending Order',
        ],
        bullets: [
          'F9 เปิดหน้าต่าง New Order',
          'ระบบเลือกคู่เงินให้ตามกราฟที่เปิดอยู่',
          'มีช่อง SL และ TP อยู่ในหน้าเดียว',
          'เลือก Market หรือ Pending ได้จากช่อง Type',
        ],
      },
      {
        heading: 'กำหนดขนาดล็อตให้ตรงความเสี่ยง',
        paragraphs: [
          'ช่อง Volume กรอกเป็นล็อต โดย 1.00 Lot = 100,000 หน่วย และ EURUSD 1 Pip มีค่าประมาณ 10 ดอลลาร์ต่อ 1 Lot',
          'ถ้าพอร์ต 1,000 ดอลลาร์เสี่ยง 1% คือ 10 ดอลลาร์ และตั้ง Stop Loss 20 Pip สูตรคือ 10 หารด้วย (20 คูณ 10) ได้ 0.05 Lot',
        ],
        bullets: [
          'Volume เป็นล็อต ไม่ใช่จำนวนเงิน',
          'ขนาดล็อต = เงินที่ยอมเสีย ÷ (Pip × มูลค่าต่อ Pip)',
          'ถ้าคำนวณไม่ได้ให้ใช้ 0.01 Lot ก่อน',
          'ตรวจทิศทาง Buy หรือ Sell ก่อนกดยืนยัน',
        ],
      },
      {
        heading: 'ปิดสถานะในบัญชี Netting และ Hedging',
        paragraphs: [
          'บัญชี Hedging จะเห็นแต่ละออเดอร์แยกกัน จึงปิดทีละไม้หรือปิดบางส่วนได้ ส่วนบัญชี Netting จะรวมเป็นสถานะเดียว ปิดได้ทั้งก้อน',
          'วิธีปิดคือเปิดแท็บ Trade ใน Toolbox คลิกขวาที่สถานะแล้วเลือก Close Position หรือดับเบิลคลิกที่แถวนั้น',
        ],
        bullets: [
          'Hedging ปิดทีละไม้ได้',
          'Netting ปิดทั้งสถานะเป็นก้อนเดียว',
          'คลิกขวา > Close Position',
          'ตรวจ Volume ก่อนยืนยันปิด',
        ],
      },
      {
        heading: 'ข้อผิดพลาดที่พบบ่อย',
        paragraphs: [
          'กรณีที่พบบ่อยคือกด Close แล้วขึ้น No connection หรือ Requote เพราะราคาเปลี่ยนระหว่างกดยืนยัน ให้ตรวจราคาใหม่แทนการกดซ้ำเร็ว ๆ',
          'อีกกรณีคือเปิดออเดอร์ซ้ำโดยไม่รู้ตัวในบัญชี Netting เพราะเข้าใจว่าเป็นการถือสองไม้ แต่ระบบรวมเป็นไม้เดียวและเพิ่มขนาดความเสี่ยงเป็นสองเท่า',
        ],
        bullets: [
          'Requote = ราคาเปลี่ยน ให้ตรวจใหม่',
          'Netting รวมไม้ทิศเดียวกันเข้าด้วยกัน',
          'ตรวจ Volume รวมก่อนเปิดไม้เพิ่ม',
          'ตั้ง Stop Loss ทุกไม้ توسطไม่มีข้อยกเว้น',
        ],
      },
    ],
    faqs: [
      {
        q: 'Netting กับ Hedging ต่างกันอย่างไร',
        a: 'Netting รวมออเดอร์ทิศเดียวกันเป็นสถานะเดียว ส่วน Hedging ถือแยกได้หลายออเดอร์พร้อมกัน',
        a2: 'ผลในทางปฏิบัติคือถ้าถือ Buy 0.10 Lot แล้วเปิด Buy เพิ่ม 0.10 Lot ในบัญชี Netting คุณจะมีสถานะเดียวขนาด 0.20 Lot และปิดแยกไม่ได้ แต่ในบัญชี Hedging จะมีสองไม้แยกกันและปิดทีละไม้ได้ การรู้ประเภทบัญชีจึงสำคัญก่อนวางแผนปิดทำกำไร',
      },
      {
        q: 'เปิดออเดอร์ขั้นต่ำเท่าไร',
        a: 'ส่วนใหญ่เริ่มที่ 0.01 Lot หรือ 1,000 หน่วย ซึ่งคิดเป็นประมาณ 0.10 ดอลลาร์ต่อ Pip สำหรับ EURUSD',
        a2: 'บางโบรกเกอร์กำหนดขั้นต่ำ 0.10 Lot สำหรับบัญชีมาตรฐาน และบัญชี Micro อาจเริ่ม 0.01 Lot ถ้าพอร์ตเริ่มต้น 500 ดอลลาร์ การใช้ 0.01 Lot ทำให้เสี่ยงเพียง 0.10 ดอลลาร์ต่อ Pip ซึ่งเล็กพอจะฝึกได้โดยไม่กระทบเงินต้น',
      },
      {
        q: 'กด Buy แล้วราคาเข้าสูงกว่าที่เห็น',
        a: 'เพราะ Buy เข้าที่ Ask ซึ่งสูงกว่า Bid บนกราฟอยู่แล้วหนึ่ง Spread และอาจมีสลิปเพจถ้าตลาดเร็ว',
        a2: 'ตัวอย่างเช่นกราฟแสดง 1.08540 แต่ Ask คือ 1.08552 แปลว่า Spread 1.2 Pip ถูกหักทันที ถ้าเปิด 0.10 Lot ต้นทุนนี้ประมาณ 1.2 ดอลลาร์ ซึ่งต้องบวกเข้าเป้ากำไรของคุณทุกครั้ง',
      },
    ],
  },
  'mt5-set-sl-tp': {
    intro: [
      'Stop Loss และ Take Profit ใน MT5 กรอกเป็นระดับราคาในหน้าต่าง New Order หรือแก้ไขภายหลังได้จากแท็บ Trade',
      'ทั้งสองค่านี้คือเครื่องมือจำกัดความเสี่ยงที่สำคัญที่สุด และควรตั้งทุกไม้โดยไม่มีข้อยกเว้น',
    ],
    sections: [
      {
        heading: 'ความต่างของสองค่า',
        paragraphs: [
          'Stop Loss คือระดับที่คุณยอมขาดทุนและออกอัตโนมัติ ส่วน Take Profit คือระดับที่พอใจกับกำไรและปิดออเดอร์',
          'สำหรับ Buy นั้น Stop Loss อยู่ต่ำกว่าราคาเข้าและ Take Profit อยู่สูงกว่า ส่วน Sell กลับกัน ถ้ากรอกสลับทิศจะขึ้น Invalid stops',
        ],
        bullets: [
          'Buy: SL ต่ำกว่า, TP สูงกว่าราคาเข้า',
          'Sell: SL สูงกว่า, TP ต่ำกว่าราคาเข้า',
          'กรอกเป็นระดับราคา เช่น 1.08200',
          'ระยะต้องห่างเกินขั้นต่ำของคู่นั้น',
        ],
      },
      {
        heading: 'คำนวณจากเงินที่ยอมเสีย',
        paragraphs: [
          'อย่าตั้ง Stop Loss ตามความรู้สึก ให้คำนวณย้อนกลับจากเงินที่ยอมเสีย สูตรคือ Pip ที่รับได้ = เงินที่ยอมเสีย ÷ (ล็อต × มูลค่าต่อ Pip)',
          'ตัวอย่าง พอร์ต 2,000 ดอลลาร์ เสี่ยง 1% คือ 20 ดอลลาร์ ถ้าเทรด 0.10 Lot บน EURUSD ซึ่ง 1 Pip = 1 ดอลลาร์ จะรับได้ 20 Pip',
        ],
        bullets: [
          'คำนวณจากเงินที่ยอมเสียก่อน',
          '1% ของพอร์ตคือเพดานสำหรับมือใหม่',
          '20 Pip กับ 0.10 Lot = เสี่ยง 20 ดอลลาร์',
          'จดตัวเลขนี้ก่อนกดยืนยัน',
        ],
      },
      {
        heading: 'แก้ไขหลังเปิดออเดอร์แล้ว',
        paragraphs: [
          'คลิกขวาที่สถานะในแท็บ Trade แล้วเลือก Modify Position เพื่อเติมหรือเลื่อนจุดทั้งสอง ค่าใหม่จะใช้ทันทีถ้าระยะผ่านเงื่อนไข',
          'การเลื่อน Stop Loss ทำได้ทั้งเพื่อลดความเสี่ยงและเพื่อทำ trailing stop แต่ควรเลื่อนตามโครงสร้างราคา ไม่ใช่เลื่อนหนีการขาดทุน',
        ],
        bullets: [
          'Modify Position ใช้แก้ทั้ง SL และ TP',
          'เลื่อน Stop Loss ได้ในทิศที่ลดความเสี่ยง',
          'ตรวจว่าแสดงในแท็บ Trade หลังแก้ไข',
          'อย่าเลื่อน Stop Loss ออกเพื่อหนีขาดทุน',
        ],
      },
      {
        heading: 'ข้อผิดพลาดที่พบบ่อย',
        paragraphs: [
          'ปัญหา Invalid stops เกิดจากระยะใกล้ราคาปัจจุบันเกินไป ซึ่งแต่ละคู่กำหนดไม่เท่ากัน คู่เงินหลักมักต้องห่างอย่างน้อย 10-20 Point',
          'อีกข้อคือตั้ง Take Profit ไกลเกินจริงโดยไม่มีเหตุผลเชิงกราฟ ทำให้ออเดอร์ค้างนานและถูกปิดด้วย Stop Loss ก่อน',
        ],
        bullets: [
          'Invalid stops = ระยะใกล้เกินไป',
          'ตั้ง TP ให้สอดคล้องแนวต้านแนวรับจริง',
          'ตรวจ Specification เพื่อดูระยะขั้นต่ำ',
          'ตั้ง SL ทุกไม้ไม่มีข้อยกเว้น',
        ],
      },
    ],
    faqs: [
      {
        q: 'Stop Loss ควรห่างกี่ Pip',
        a: 'ขึ้นกับความผันผวนและกรอบเวลาที่เทรด ไม่มีตัวเลขเดียวที่ใช้ได้ทุกสถานการณ์',
        a2: 'เกณฑ์ที่ใช้ได้จริงคือให้ Stop Loss อยู่เหนือหรือใต้ swing low / swing high ล่าสุดราว 5-10 Pip บน H1 ซึ่งมักได้ระยะ 20-40 Pip สำหรับคู่เงินหลัก ถ้าระยะที่ได้น้อยกว่า 15 Pip แปลว่าจุดเข้าอยู่ใกล้แนวมากเกินไปจนไม่น่าลงทุน',
      },
      {
        q: 'ตั้ง Take Profit ต้องใหญ่กว่า Stop Loss ไหม',
        a: 'ไม่จำเป็น แต่ต้องรู้ว่าถ้า TP เล็กกว่า SL ต้องชนะบ่อยขึ้นจึงจะไม่ขาดทุน',
        a2: 'ตัวเลขที่ช่วยได้คือถ้า TP 20 Pip และ SL 40 Pip คุณต้องชนะมากกว่า 67% จึงจะเท่าทุน ส่วน TP 40 กับ SL 20 ต้องการเพียง 34% สำหรับมือใหม่ที่อัตราชนะราว 50% การตั้ง TP อย่างน้อยเท่ากับ SL ปลอดภัยกว่ามาก',
      },
      {
        q: 'แก้ออเดอร์แล้วขึ้น Invalid stops',
        a: 'หมายถึงระยะที่ตั้งใกล้ราคาปัจจุบันเกินกว่าที่โบรกเกอร์อนุญาต ให้เลื่อนออกไปอีกเล็กน้อย',
        a2: 'ตรวจระยะขั้นต่ำได้จากคลิกขวาที่คู่เงินใน Market Watch เลือก Specification แล้วดูหัวข้อ Stops level ซึ่งมักเป็น 0 หรือ 10-30 Point ถ้ายังไม่ผ่านให้เลื่อนออกไปอีก 5-10 Pip อย่าลดระยะ Stop Loss เพื่อให้ระบบรับ เพราะนั่นคือการเพิ่มความเสี่ยง',
      },
    ],
  },
  'mt5-trade-history': {
    intro: [
      'ประวัติการเทรดใน MT5 อยู่ที่แท็บ History ของ Toolbox และมีรายละเอียดค่าคอมมิชชันกับสวอปแยกให้ดู',
      'ข้อมูลนี้คือวัตถุดิบสำคัญของการทบทวนผลงาน เพราะความจำของคนเราเก็บได้ไม่ถึงครึ่งของสิ่งที่เกิดขึ้นจริง',
    ],
    sections: [
      {
        heading: 'เปิดแท็บ History',
        paragraphs: [
          'เปิดแท็บ History ในหน้าต่าง Toolbox ด้านล่าง ซึ่งแยกดูได้สามแบบคือ Positions, Orders และ Deals ตามสิ่งที่ต้องการตรวจ',
          'ถ้าไม่เห็นรายการ ให้คลิกขวาในช่วงว่างแล้วเลือก Period เพื่อกำหนดช่วงวันที่ เพราะค่าเริ่มต้นอาจกรองแค่ช่วงสั้น ๆ',
        ],
        bullets: [
          'History อยู่ใน Toolbox ด้านล่าง',
          'ดูได้ทั้ง Positions, Orders และ Deals',
          'คลิกขวา > Period กำหนดช่วงวันที่',
          'กด Ctrl+T ถ้า Toolbox ถูกปิด',
        ],
      },
      {
        heading: 'อ่านตัวเลขให้เป็น',
        paragraphs: [
          'แต่ละแถวแสดงเวลาเปิด-ปิด สินทรัพย์ ทิศทาง ขนาดล็อต ราคาเข้า-ออก และผลลัพธ์เป็นตัวเงิน ซึ่งหักสวอปและคอมมิชชันแล้ว',
          'ถ้าต้องการดูต้นทุนแยก ให้เปลี่ยนไปดูแท็บ Deals ซึ่งแสดงค่าคอมมิชชันและสวอปของแต่ละธุรกรรมอย่างชัดเจน',
        ],
        bullets: [
          'Profit คือยอดสุทธิหลังหักต้นทุน',
          'Swap คือค่าถือข้ามคืน อาจบวกหรือลบ',
          'Deals แสดงค่าธรรมเนียมแยกทีละรายการ',
          'ดูเวลาเปิด-ปิดเพื่อรู้ระยะเวลาถือไม้',
        ],
      },
      {
        heading: 'ส่งออกข้อมูลไปวิเคราะห์ต่อ',
        paragraphs: [
          'คลิกขวารายการแล้วเลือก Save as Report เพื่อเก็บเป็นไฟล์ HTML หรือ Save as Detailed Report สำหรับไฟล์ที่มีรายละเอียดครบ',
          'ถ้าต้องการวิเคราะห์ในสเปรดชีต ให้ใช้ Save as Report แล้วคัดลอกตารางไปวาง ซึ่งใช้เวลาไม่ถึงหนึ่งนาทีต่อเดือน',
        ],
        bullets: [
          'Save as Report ได้ไฟล์ HTML',
          'Detailed Report มีค่าธรรมเนียมครบ',
          'คัดลอกลงสเปรดชีตเพื่อวิเคราะห์ต่อ',
          'เก็บไฟล์รายเดือนไว้เทียบผลระยะยาว',
        ],
      },
      {
        heading: 'ข้อผิดพลาดที่พบบ่อย',
        paragraphs: [
          'ถ้าประวัติไม่ขึ้น ให้ตรวจตัวกรองช่วงวันที่และตรวจว่าล็อกอินบัญชีที่เคยเทรดหรือไม่ เพราะบัญชีทดลองแยกประวัติจากบัญชีจริง',
          'อีกกรณีคือประวัติไม่ครบหลังเปลี่ยนเครื่อง เพราะ MT5 เก็บประวัติในเครื่อง ไม่ได้ซิงก์ข้ามเครื่องอัตโนมัติ',
        ],
        bullets: [
          'ตรวจตัวกรองวันที่ก่อนสรุปว่าหาย',
          'บัญชีทดลองและจริงแยกประวัติ',
          'เปลี่ยนเครื่องประวัติเดิมไม่ตามมา',
          'ส่งออกไฟล์เก็บไว้ทุกเดือน',
        ],
      },
    ],
    faqs: [
      {
        q: 'ทำไมประวัติการเทรดไม่ขึ้น',
        a: 'ส่วนใหญ่เกิดจากตัวกรองช่วงวันที่ไม่ครอบคลุม หรือกำลังดูผิดแท็บระหว่าง Positions กับ Orders',
        a2: 'ให้คลิกขวาในแท็บ History เลือก Period แล้วกำหนดช่วงกว้าง ๆ ก่อน วิธีตรวจที่เร็วที่สุดคือเลือก All History ถ้ายังว่างให้ตรวจเลขบัญชีมุมขวาล่างว่าตรงกับบัญชีที่เคยเทรด และตรวจว่าได้ล็อกอินบนเครื่องนี้ตอนเทรดหรือไม่',
      },
      {
        q: 'ดูค่าสวอปและคอมมิชชันได้จากไหน',
        a: 'ดูได้จากแท็บ Deals หรือจาก Detailed Report ที่แสดงค่าธรรมเนียมแยกทุกธุรกรรม',
        a2: 'ตัวเลขที่ควรจับตาคือถ้าค่าสวอปรวมต่อเดือนเกิน 5% ของกำไรขั้นต้น แปลว่าการถือข้ามคืนกำลังกินผลตอบแทน ให้พิจารณาถือไม้นานขึ้นแต่น้อยไม้ลง หรือเลือกคู่เงินที่มีสวอปถูกกว่า',
      },
      {
        q: 'ประวัติเก็บไว้นานแค่ไหน',
        a: 'ขึ้นกับโบรกเกอร์ ส่วนใหญ่เก็บในเซิร์ฟเวอร์ 3-12 เดือน แต่ในเครื่องจะอยู่จนกว่าจะลบโฟลเดอร์ข้อมูล',
        a2: 'ถ้าต้องการเก็บระยะยาวให้ส่งออกเป็นไฟล์รายเดือนแล้วเก็บเอง เพราะเมื่อโบรกเกอร์ล้างข้อมูลเก่า ประวัติจะหายจากแพลตฟอร์ม ไฟล์ HTML เดือนละหนึ่งไฟล์ใช้พื้นที่ไม่ถึง 1 MB และช่วยให้ย้อนดูผลงานข้ามปีได้',
      },
    ],
  },
  'mt5-chart-not-showing': {
    intro: [
      'กราฟ MT5 ว่างหรือโหลดค้างส่วนใหญ่มาจากการเชื่อมต่อหรือจำนวนแท็บกราฟที่เปิดไว้มากเกินไป',
      'ตรวจสถานะมุมขวาล่างก่อนเสมอ เพราะเป็นจุดที่บอกสาเหตุได้เร็วที่สุด',
    ],
    sections: [
      {
        heading: 'ตรวจการเชื่อมต่อก่อน',
        paragraphs: [
          'มุมขวาล่างแสดงสถานะเชื่อมต่อและตัวเลข ping ถ้าเห็นตัวเลขวิ่งแสดงว่าปกติ ปัญหาอยู่ที่อื่น',
          'ถ้าขึ้น No connection ให้ตรวจอินเทอร์เน็ตแล้วล็อกอินใหม่ผ่าน File > Login to Trade Account',
        ],
        bullets: [
          'ตัวเลข ping วิ่ง = เชื่อมต่อปกติ',
          'No connection = ล็อกอินใหม่',
          'ปิด VPN ถ้าเชื่อมต่อไม่ได้',
          'ตรวจไฟร์วอลล์ว่าไม่ได้บล็อก MT5',
        ],
      },
      {
        heading: 'ถ้าเชื่อมต่อปกติแต่กราฟว่าง',
        paragraphs: [
          'คลิกขวาที่กราฟเลือก Refresh เพื่อดึงข้อมูลใหม่ บางครั้งกราฟค้างเพราะข้อมูลเก่าถูกโหลดค้างไว้',
          'ถ้ายังว่าง ให้ตรวจว่าสินทรัพย์นั้นยังเปิดให้เทรดอยู่หรือไม่ เพราะหุ้นและดัชนีมีเวลาเปิดปิดต่างจาก Forex',
        ],
        bullets: [
          'Refresh ดึงข้อมูลใหม่',
          'ตรวจว่าเป็นช่วงปิดตลาดหรือไม่',
          'ลองเปลี่ยนไปคู่เงินหลักเพื่อทดสอบ',
          'ปิดกราฟที่ไม่ใช้ออกบ้าง',
        ],
      },
      {
        heading: 'ลดจำนวนกราฟที่เปิดพร้อมกัน',
        paragraphs: [
          'MT5 กินทรัพยากรมากกว่า MT4 เล็กน้อย การเปิดกราฟ 10 หน้าต่างพร้อมอินดิเคเตอร์อาจใช้แรมเกิน 1.5 GB จนเริ่มกระตุก',
          'ถ้าเครื่องแรม 8 GB แนะนำไม่เกิน 4-6 กราฟพร้อมกัน และปิดแท็บ Economic Calendar เมื่อไม่ได้ดู',
        ],
        bullets: [
          'ไม่ควรเปิดเกิน 6 กราฟบนเครื่องทั่วไป',
          'ปิดแท็บปฏิทินเมื่อไม่ใช้',
          'ลดกราฟ M1 ที่กินทรัพยากรหนัก',
          'ปิดโปรแกรมอื่นที่ไม่จำเป็น',
        ],
      },
      {
        heading: 'เมื่อไรควรติดต่อโบรกเกอร์',
        paragraphs: [
          'ถ้าเชื่อมต่อปกติ เปลี่ยนสินทรัพย์แล้วยังว่าง และเป็นเวลาที่ตลาดเปิดจริง ให้ติดต่อฝ่ายบริการลูกค้าพร้อมแจ้งชื่อเซิร์ฟเวอร์และเวลาเกิดปัญหา',
          'ก่อนติดต่อให้ลองลบไฟล์ history ของสินทรัพย์นั้นในโฟลเดอร์ข้อมูล แล้วรีสตาร์ตโปรแกรม ซึ่งแก้ข้อมูลเสียได้บ่อย',
        ],
        bullets: [
          'แจ้งชื่อเซิร์ฟเวอร์และเวลาเกิดปัญหา',
          'ลองลบไฟล์ history ของสินทรัพย์นั้น',
          'เก็บภาพหน้าจอไว้ประกอบการแจ้ง',
          'ตรวจว่าบัญชีไม่ได้ถูกจำกัดการเข้าถึง',
        ],
      },
    ],
    faqs: [
      {
        q: 'กราฟ MT5 ว่างแต่ Market Watch มีราคา',
        a: 'แปลว่าเชื่อมต่อปกติแต่กราฟไม่ได้รับข้อมูล ให้กด Refresh ที่กราฟก่อน',
        a2: 'ถ้าไม่หาย ให้ปิดกราฟนั้นแล้วเปิดใหม่จาก File > New Chart ซึ่งจะสร้างกราฟใหม่ที่ดึงข้อมูลครบ ถ้ายังว่างให้ตรวจว่ากราฟตั้งเป็น Online อยู่หรือไม่ โดยดูมุมขวาบนของกราฟ ถ้าไม่มีคำว่า Online แปลว่ากราฟถูกตัดการอัปเดต',
      },
      {
        q: 'ทำไมกราฟหายไปหลายวัน',
        a: 'ส่วนใหญ่เกิดจากไฟล์ประวัติในเครื่องเสียหรือถูกจำกัดจำนวนแท่งที่โหลด',
        a2: 'ให้เปิด File > Open Data Folder แล้วไปที่โฟลเดอร์ bases หรือ history ลบไฟล์ของสินทรัพย์นั้นแล้วรีสตาร์ต MT5 ระบบจะดาวน์โหลดใหม่ ใช้เวลาราว 1-3 นาที ขึ้นกับความเร็วเน็ตและจำนวนแท่งที่ขอ',
      },
      {
        q: 'กราฟขึ้น Waiting for update ตลอด',
        a: 'หมายถึงรอข้อมูลจากเซิร์ฟเวอร์ ซึ่งมักมาจากการเชื่อมต่อสะดุดหรือสินทรัพย์นั้นปิดตลาด',
        a2: 'ให้ตรวจสถานะมุมขวาล่างก่อน ถ้าเป็น No connection ให้ล็อกอินใหม่ ถ้าเชื่อมต่อปกติแต่ยังรอ ให้ตรวจว่าเป็นช่วงสุดสัปดาห์หรือวันหยุดของตลาดนั้น และบางครั้งต้องรีสตาร์ตโปรแกรมหนึ่งครั้งก่อนข้อมูลจะกลับมา',
      },
    ],
  },
  'mt5-find-indicator-trouble': {
    intro: [
      'อินดิเคเตอร์ที่หาไม่เจออาจอยู่ใต้หมวด Custom หรือยังไม่ได้ติดตั้งลงในโฟลเดอร์ของแพลตฟอร์ม',
      'การไล่ตรวจตามลำดับช่วยแยกสาเหตุได้ภายใน 2-3 นาที',
    ],
    sections: [
      {
        heading: 'ตรวจทั้ง Indicators และ Custom',
        paragraphs: [
          'เปิด Navigator ด้วย Ctrl+N แล้วพิมพ์ชื่อบางส่วนในช่องค้นหา อินดิเคเตอร์ที่ติดมากับโปรแกรมจะอยู่ใต้ Indicators',
          'อินดิเคเตอร์ที่โหลดจากภายนอกจะอยู่ใต้ Custom ซึ่งเป็นจุดที่คนหาไม่เจอบ่อยที่สุด',
        ],
        bullets: [
          'Ctrl+N เปิด Navigator',
          'อินดิเคเตอร์ในตัวอยู่ใต้ Indicators',
          'อินดิเคเตอร์โหลดมาเองอยู่ใต้ Custom',
          'พิมพ์ชื่อบางส่วนเพื่อกรอง',
        ],
      },
      {
        heading: 'ตรวจไฟล์ในโฟลเดอร์ติดตั้ง',
        paragraphs: [
          'ถ้าไม่มีจริง ให้เปิด File > Open Data Folder แล้วไปที่ MQL5 > Indicators ตรวจว่าไฟล์ .ex5 อยู่ที่นั่น',
          'ไฟล์ของ MT4 เป็น .ex4 ซึ่งใช้กับ MT5 ไม่ได้ เพราะใช้ภาษาคนละตัว ต้องหาเวอร์ชัน MT5 แยก',
        ],
        bullets: [
          'ไฟล์ MT5 ต้องเป็น .ex5',
          'ไฟล์ .ex4 ของ MT4 ใช้ไม่ได้',
          'ปิดโปรแกรมก่อนคัดลอกไฟล์',
          'หลังคัดลอกให้รีสตาร์ตหนึ่งครั้ง',
        ],
      },
      {
        heading: 'กรณีอินดิเคเตอร์ขึ้นแต่ไม่แสดง',
        paragraphs: [
          'ถ้าชื่อขึ้นในรายการแต่ไม่มีเส้น ให้ตรวจสีและความหนาในแท็บ Colors เพราะบางครั้งตั้งเป็นสีเดียวกับพื้นหลัง',
          'ถ้ายังไม่เห็นให้ตรวจว่าเส้นถูกวาดในหน้าต่างย่อยที่ถูกซ่อนอยู่ โดยย่อ Toolbox ลงเพื่อให้เห็นพื้นที่ด้านล่างทั้งหมด',
        ],
        bullets: [
          'ตรวจสีและความหนาของเส้น',
          'ย่อ Toolbox เพื่อเห็นหน้าต่างย่อย',
          'กด Reset กลับค่าเริ่มต้นเพื่อทดสอบ',
          'ตรวจแท็บ Experts ดูข้อความ error',
        ],
      },
      {
        heading: 'เมื่อต้องติดตั้งใหม่',
        paragraphs: [
          'ปิดโปรแกรมก่อนคัดลอกไฟล์ลงโฟลเดอร์ MQL5 > Indicators แล้วเปิดใหม่หนึ่งครั้ง เพื่อให้ระบบสแกนรายการครบ',
          'ถ้าเคยมีอินดิเคเตอร์ทำงานอยู่ก่อนอัปเดตแพลตฟอร์ม ควรสำรองโฟลเดอร์ MQL5 ไว้ เพราะตัวอัปเดตอาจสร้างโฟลเดอร์ใหม่',
        ],
        bullets: [
          'ปิดโปรแกรมก่อนคัดลอกไฟล์',
          'สำรอง MQL5 ก่อนอัปเดตแพลตฟอร์ม',
          'รีสตาร์ตหนึ่งครั้งหลังติดตั้ง',
          'ตรวจว่าไฟล์ไม่ถูกบล็อกโดย Windows',
        ],
      },
    ],
    faqs: [
      {
        q: 'อินดิเคเตอร์ MT4 ใช้กับ MT5 ได้ไหม',
        a: 'ไม่ได้ เพราะ MT4 ใช้ภาษา MQL4 และ MT5 ใช้ MQL5 ซึ่งเป็นคนละภาษาและคนละรูปแบบไฟล์',
        a2: 'ไฟล์ของ MT4 เป็นนามสกุล .ex4 ส่วน MT5 ต้องเป็น .ex5 ถ้าต้องการอินดิเคเตอร์ตัวเดียวกันบน MT5 ต้องหาจากผู้พัฒนาที่ออกเวอร์ชัน MQL5 หรือเขียนใหม่ ซึ่งใช้เวลาเรียนรู้ราว 2-4 สัปดาห์สำหรับคนที่มีพื้นฐานเขียนโปรแกรม',
      },
      {
        q: 'หาใน Navigator ไม่เจอแต่ไฟล์อยู่ในโฟลเดอร์',
        a: 'อาจยังไม่ได้รีสตาร์ตโปรแกรมหลังคัดลอกไฟล์ หรือไฟล์เสียหาย',
        a2: 'ให้ปิด MT5 แล้วเปิดใหม่หนึ่งครั้ง ระบบจะสแกนโฟลเดอร์ MQL5 ใหม่ทั้งหมด ใช้เวลาราว 10-20 วินาที ถ้ายังไม่ขึ้นให้ตรวจว่าไฟล์มีขนาดมากกว่า 0 KB และไม่ได้ถูกบล็อกจาก Windows โดยคลิกขวาที่ไฟล์แล้วเลือก Properties',
      },
      {
        q: 'อินดิเคเตอร์ขึ้นแต่เส้นไม่ขยับ',
        a: 'อาจตั้งกรอบเวลาผิด หรืออินดิเคเตอร์คำนวณจากแท่งที่ยังไม่ปิดจึงอัปเดตเฉพาะตอนแท่งจบ',
        a2: 'ให้ตรวจว่ากราฟตั้งเป็น Online และรอให้แท่งปัจจุบันปิดก่อน ถ้ายังนิ่งเกิน 1 ชั่วโมงบนกรอบ H1 แปลว่ามีปัญหา ให้ลบแล้วเพิ่มใหม่ หรือตรวจว่าเครื่องยังได้รับข้อมูลราคาปกติ',
      },
    ],
  },
  'mt5-cannot-login': {
    intro: [
      'ล็อกอิน MT5 ไม่ผ่านมักมาจากเซิร์ฟเวอร์ไม่ตรง รหัสผ่านผิด หรือบัญชีถูกสร้างสำหรับแพลตฟอร์มอื่น',
      'ข้อความแจ้งเตือนของ MT5 บอกสาเหตุค่อนข้างชัด ถ้ารู้วิธีอ่านจะแก้ได้เองในเกือบทุกกรณี',
    ],
    sections: [
      {
        heading: 'อ่านข้อความแจ้งเตือน',
        paragraphs: [
          'Invalid account หมายถึงเลขบัญชีหรือรหัสผ่านไม่ตรงกับเซิร์ฟเวอร์ที่เลือก ส่วน Invalid server หมายถึงไม่มีเซิร์ฟเวอร์ชื่อนั้น',
          'Account disabled คือบัญชีถูกระงับ ซึ่งต่างจากรหัสผิด และ No connection คือเชื่อมต่อเซิร์ฟเวอร์ไม่ได้เลย',
        ],
        bullets: [
          'Invalid account = เลขบัญชีหรือรหัสผิด',
          'Invalid server = ชื่อเซิร์ฟเวอร์ไม่ถูก',
          'Account disabled = บัญชีถูกระงับ',
          'No connection = เชื่อมต่อเซิร์ฟเวอร์ไม่ได้',
        ],
      },
      {
        heading: 'ตรวจว่าเป็นบัญชี MT5 จริง',
        paragraphs: [
          'บัญชีที่เปิดไว้สำหรับ MT4 ไม่สามารถใช้ล็อกอิน MT5 ได้โดยตรงในหลายโบรกเกอร์ ต้องสอบถามว่าต้องเปิดบัญชีใหม่หรือไม่',
          'อีกจุดคือประเภทบัญชี Netting กับ Hedging ต้องเลือกเซิร์ฟเวอร์ให้ตรงกับที่สมัครไว้ จึงจะล็อกอินผ่าน',
        ],
        bullets: [
          'ตรวจว่าเซิร์ฟเวอร์มีคำว่า MT5',
          'บัญชี MT4 อาจใช้กับ MT5 ไม่ได้',
          'ประเภทบัญชีต้องตรงกับที่สมัคร',
          'ตรวจเลขบัญชีว่าครบทุกหลัก',
        ],
      },
      {
        heading: 'ตรวจรหัสผ่านและเครือข่าย',
        paragraphs: [
          'พิมพ์รหัสผ่านใหม่โดยตรวจตัวพิมพ์ใหญ่เล็กและปิด Caps Lock เพราะข้อความ error เดียวกันนี้เกิดจากรหัสผิดได้บ่อย',
          'ถ้าใช้ VPN หรือเครือข่ายองค์กร ให้ลองปิดแล้วเชื่อมต่อใหม่ เพราะบางเครือข่ายบล็อกพอร์ตที่แพลตฟอร์มใช้',
        ],
        bullets: [
          'ตรวจ Caps Lock และช่องว่าง',
          'ปิด VPN แล้วลองใหม่',
          'ลองเครือข่ายอื่นถ้าทำได้',
          'ล็อกอินบัญชีทดลองเพื่อแยกสาเหตุ',
        ],
      },
      {
        heading: 'เมื่อต้องติดต่อโบรกเกอร์',
        paragraphs: [
          'ถ้าตรวจครบแล้วยังไม่ผ่าน ให้ติดต่อโบรกเกอร์พร้อมแจ้งเลขบัญชี ข้อความ error และเวลาที่เกิดปัญหา',
          'บัญชีทดลองที่ไม่ได้ใช้งานนานหลายสัปดาห์มักถูกปิดอัตโนมัติ กรณีนี้ไม่ใช่รหัสผิด แต่ต้องเปิดบัญชีทดลองใหม่',
        ],
        bullets: [
          'แจ้งเลขบัญชีและข้อความ error',
          'บัญชีทดลองอาจหมดอายุ',
          'ขอรีเซ็ตรหัสผ่านได้ที่ Client Portal',
          'เก็บภาพหน้าจอ error ไว้',
        ],
      },
    ],
    faqs: [
      {
        q: 'บัญชี MT4 ใช้ล็อกอิน MT5 ได้ไหม',
        a: 'โดยทั่วไปไม่ได้ เพราะโบรกเกอร์แยกบัญชีตามแพลตฟอร์ม ต้องสอบถามหรือเปิดบัญชีใหม่',
        a2: 'บางโบรกเกอร์ให้เลขบัญชีเดียวกันใช้ได้ทั้งสองแพลตฟอร์ม แต่ประวัติการเทรดจะแยกกัน คำถามที่ควรถามให้ชัดคือ ใช้เลขบัญชีเดิมได้ไหม มีค่าธรรมเนียมโอนย้ายไหม และประวัติเดิมยังดูได้หรือไม่',
      },
      {
        q: 'ล็อกอินไม่ผ่านแต่รหัสถูกแน่ ๆ',
        a: 'ให้ตรวจชื่อเซิร์ฟเวอร์ก่อน เพราะกรณีส่วนใหญ่ที่รหัสถูกแต่เข้าไม่ได้เกิดจากเลือกเซิร์ฟเวอร์ผิด',
        a2: 'วิธีตรวจที่เร็วที่สุดคือเปิดอีเมลของโบรกเกอร์แล้วคัดลอกชื่อเซิร์ฟเวอร์มาเทียบทีละตัวอักษร โดยเฉพาะตัวเลขท้าย เช่น Live01 กับ Live02 ถ้าเลือกผิดระบบจะขึ้น Invalid account ทันทีแม้รหัสจะถูกต้อง',
      },
      {
        q: 'ขึ้น Account disabled ต้องทำอย่างไร',
        a: 'ต้องติดต่อโบรกเกอร์เท่านั้น เพราะเป็นการระงับจากฝั่งเซิร์ฟเวอร์ ไม่สามารถแก้จากแพลตฟอร์มได้',
        a2: 'สาเหตุที่พบบ่อยคือยังไม่ได้ส่งเอกสารยืนยันตัวตน บัญชีไม่ได้ใช้งานนานเกินกำหนด หรือมีปัญหาด้านความปลอดภัย ให้เตรียมบัตรประชาชนและหลักฐานที่อยู่ไว้พร้อม โดยทั่วไปใช้เวลาตรวจ 1-3 วันทำการ',
      },
    ],
  },
};